<!--
 * @Author: DY
 * @Date: 2020-08-31 20:25:29
 * @LastEditors: name
 * @LastEditTime: 2020-09-04 16:13:32
 * @Describe:
-->
<template>
    <div class="miniMap">
        <baidu-map
            class="baidu-map"
            :zoom="zoom_min"
            :center="mapCenter_min"
            ak="8oGi1YBeLNnGA54yA1YuyumkzjjfGqmW"
            @ready="handleReady"
        >
            <bm-marker
                :position="marker.position"
                :icon="marker.icon"
            ></bm-marker>
            <bm-info-window
                :position="Info.position"
                :offset="Info.offset"
                :show="Info.visible"
                auto-pan
            >
                <div class="engineering_Info">
                    {{ Info.content }}
                </div>
            </bm-info-window>
        </baidu-map>
    </div>
</template>
<script>

import mapSkin from '@/assets/map/midnight.js';
import BaiduMap from 'vue-baidu-map-v3/components/map/Map.vue';
import BmMarker from 'vue-baidu-map-v3/components/overlays/Marker.vue';
import BmInfoWindow from 'vue-baidu-map-v3/components/overlays/InfoWindow.vue';
import url from '@/views/lifeCycle/images/icon.png';
export default {
    // 小地图
    name: 'mini-map',
    components: { BaiduMap, BmMarker, BmInfoWindow },
    props: {
        essentialInfo: {
            type: [Array, Object, String],
        },
        mapKey: {
            type: [Array, Object, String],
        },
    },
    data() {
        return {
            zoom_min: 10,
            // 地图中心点坐标值
            mapCenter_min: { lng: 117.120098, lat: 36.6512 },
            marker: {
                icon: {
                    url: require('./images/icon.png'),
                    size: {
                        width: 24,
                        height: 24,
                    },
                },
                position: { lng: 117.120098, lat: 36.6512 },
            },
            Info: {
                position: { lng: 117.120098, lat: 36.6512 },
                visible: false,
                content: '',
                offset: { width: 0, height: -30 },
            },
        };
    },
    created() {
    },
    mounted() {},
    activated() {},
    update() {},
    beforeRouteUpdate() {},
    methods: {
        // 地图加载完毕
        handleReady({ BMap, map }) {
            // 开启鼠标滚动缩放地图
            map.enableScrollWheelZoom(true);
            const mapStyle = {
                styleJson: mapSkin,
            };
            map.setMapStyleV2(mapStyle);
        },
    },
    filter: {},
    computed: {},
    watch: {
        essentialInfo(newVal) {
            if (newVal) {
                if (newVal.x_coordinate_point && newVal.y_coordinate_point) {
                    this.mapCenter_min = { lng: newVal.x_coordinate_point, lat: newVal.y_coordinate_point };
                    this.marker.position = { lng: newVal.x_coordinate_point, lat: newVal.y_coordinate_point };
                    this.Info.position = { lng: newVal.x_coordinate_point, lat: newVal.y_coordinate_point };
                    this.Info.content = newVal.engineering_location;
                    this.Info.visible = true;
                }
            }
        },
    },
};
</script>

<style lang="stylus">
.miniMap
    height 100%
    .baidu-map
        width 100%
        height 100%
        .BMapLabel
            border 0!important
            background transparent!important
    .BMap_pop
        .BMap_center,.BMap_top,.BMap_bottom, > div
            border 0 !important
            background rgba(0,0,0,0)!important
            height auto!important
        img
            display none
        .BMap_bubble_content
            padding-bottom 0
        .info-sharp
            position absolute
            bottom: 1px;
            left: 50%;
            margin-left: -0.08rem;
            border-left: 0.08rem solid transparent;
            border-right: 0.08rem solid transparent;
            border-top: 0.17rem solid rgba(2,174,252,.4);
            &:after
                position: absolute;
                content: "";
                margin-left: -0.08rem;
                margin-top: -0.07rem;
                border-left: 0.08rem solid transparent;
                border-right: 0.08rem solid transparent;
                border-top: 0.08rem solid rgba(0,0,0,0.3);
                filter: blur(2px);
                z-index: -1;
    .engineering_Info
        width 100%
        height 100%
        padding 0.1rem
        border-radius: 0.04rem;
        font-size: .12rem;
        line-height: .2rem;
        color: hsla(0,0%,100%,.5);
        background: rgba(0,22,54,.8);
        -webkit-box-shadow: inset 1px 1px 20px 0 rgba(2,174,252,.8);
        box-shadow: inset 1px 1px 20px 0 rgba(2,174,252,.8);
</style>
